import { NgModule } from '@angular/core';
import { BrowserModule, Title } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { RoutesModule } from '@routes/routes.module';
import { LayoutsModule } from '@layouts/layouts.module';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { SharedModule } from '@shared/shared.module';
import { NgxSpinnerModule } from 'ngx-spinner';
import {
  PERFECT_SCROLLBAR_CONFIG,
  PerfectScrollbarConfigInterface,
  PerfectScrollbarModule
} from 'ngx-perfect-scrollbar';
import Configs from '@shared/constants/configs';
import { environment } from '@env/environment';
import System, { SYSTEM } from '@shared/constants/system';

export function createTranslateLoader(http: HttpClient): any {
  return new TranslateHttpLoader(http, 'assets/i18n/', '.json');
}

const DEFAULT_PERFECT_SCROLLBAR_CONFIG: PerfectScrollbarConfigInterface = {
  suppressScrollX: true,
  wheelPropagation: false
};

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    HttpClientModule,
    BrowserAnimationsModule,
    BrowserModule,
    RoutesModule,
    LayoutsModule,
    NgxSpinnerModule,
    PerfectScrollbarModule,
    SharedModule.forRoot(),
    TranslateModule.forRoot({
      defaultLanguage: 'en',
      loader: {
        provide: TranslateLoader,
        useFactory: (createTranslateLoader),
        deps: [HttpClient]
      }
    }),
  ],
  providers: [
    { provide: PERFECT_SCROLLBAR_CONFIG, useValue: DEFAULT_PERFECT_SCROLLBAR_CONFIG },
  ],
  bootstrap: [AppComponent]
})
export class AppModule {
  constructor(private titleService: Title) {
    const system = System.getSystem();
    localStorage.setItem('system', system);
    if (SYSTEM.B2B === system) {
      this.titleService.setTitle('B2B Service');
    }
  }
}


// print out version
console.log(`
[APP] name: ${ Configs.package.name }
[APP] ver: ${ Configs.package.version }
`);

environment.system = System.getSystem();
console.log(environment.system);
